import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 86914 93218"
    {...props}
  >
    <path
      d="M71489 75072c2486 1683 5207 3308 8143 4894 2957 1585 4894 2839 5853 3778 960 940 1429 2270 1429 3974 0 1232-547 2446-1683 3680-1135 1213-2486 1820-4092 1820-1311 0-2896-410-4737-1253-1859-842-4032-2074-6537-3679-2506-1606-5247-3466-8242-5599-5540 2819-12332 4228-20397 4228-6538 0-12392-1038-17579-3132-5167-2075-9533-5070-13037-8985-3524-3935-6166-8574-7948-13976C881 55438 0 49565 0 43222c0-6459 920-12371 2780-17774 1860-5383 4541-9963 8065-13760 3504-3779 7791-6676 12841-8673C28717 998 34453 0 40873 0c8731 0 16209 1763 22454 5306 6244 3543 10981 8553 14191 15072 3211 6518 4816 14193 4816 22981 0 13332-3622 23902-10845 31713zm-13350-9299c2368-2701 4110-5930 5247-9631 1115-3719 1683-8025 1683-12920 0-6146-998-11490-2976-15992-1996-4522-4835-7928-8515-10257-3681-2311-7928-3465-12705-3465-3386 0-6538 645-9415 1918-2897 1292-5383 3151-7459 5599-2075 2446-3718 5579-4933 9376-1193 3817-1801 8085-1801 12821 0 9690 2251 17129 6773 22356 4503 5226 10199 7830 17070 7830 2839 0 5736-587 8711-1781-1801-1332-4032-2683-6733-4013-2702-1331-4542-2369-5521-3093-998-725-1507-1762-1507-3113 0-1135 490-2153 1449-3034 939-881 1996-1312 3151-1312 3464 0 9298 2898 17481 8711z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
